import {
  Grid,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import constant from "../../config/constants";
import { useNavigate } from "react-router-dom";
import { FC } from "react";
import RouteItem, { routes } from "../../config";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

const Header: FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // const tab = useMediaQuery(theme.breakpoints.down("md"));

  const getFilteredRoutesFlat = (routes: RouteItem[]) => {
    // Initialize an empty array to store filtered routes
    let filteredRoutes: RouteItem[] = [];

    // Helper function to process each route and its sub-routes
    const processRoute = (route: RouteItem, parentPath = "") => {
      // Create full path for the current route
      const fullPath = parentPath ? `${parentPath}/${route.path}` : route.path;

      // Check if the main route should be included
      if (route.showOnHeader && route.showOnHeader > 0) {
        filteredRoutes.push({
          ...route,
          path: fullPath,
        });
      }

      // Check if the route has subRoutes and process them
      if (route.subRoutes) {
        route.subRoutes.forEach((subRoute) => {
          // Check if the subRoute should be included
          if (subRoute.showOnHeader && subRoute.showOnHeader > 0) {
            filteredRoutes.push({
              ...subRoute,
              path: `${fullPath}/${subRoute.path}`,
            });
          }
        });
      }
    };

    // Iterate through the routes array
    routes.forEach((route) => {
      processRoute(route);
    });

    return filteredRoutes;
  };

  const filteredRoutes = getFilteredRoutesFlat(routes);

  return (
    <Stack
      flexDirection={"row"}
      sx={{ width: "100%", height: "100%" }}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <Stack
        direction="row"
        alignItems={"center"}
        sx={{ height: "8vh", cursor: "pointer", py: { xs: 1, sm: 0 } }}
        onClick={() => {
          navigate("/");
        }}
      >
        <img
          height={"80%"}
          src={`${constant?.baseurl}/assets/images/logo.png`}
          alt="logo"
          loading="lazy"
        />
        <Typography
          variant="h6"
          noWrap
          color="secondary"
          sx={{ pl: { xs: 1, sm: 2 } }}
        >
          St. Xavier's School, Kolhapur
        </Typography>
      </Stack>
      <Grid
        container
        alignItems={"center"}
        justifyContent={{ xs: "center", sm: "flex-end" }}
      >
        <Grid
          item
          xs={6}
          sx={{ display: { xs: "none", lg: "inline-flex", flexGrow: 1 } }}
        >
          <nav
            style={{
              display: "flex",
              flexWrap: "nowrap",
              flexGrow: 1,
              justifyContent: "end",
            }}
          >
            {filteredRoutes?.map((navItem, i) => {
              return (
                <ul
                  key={navItem?.path + i}
                  style={{ margin: "0px 1rem", textWrap: "nowrap" }}
                >
                  <a
                    style={{ textDecoration: "none", color: "#fff" }}
                    href={navItem.path}
                  >
                    {navItem.title}
                  </a>
                </ul>
              );
            })}
          </nav>
        </Grid>
        <Grid item alignItems={"end"}>
          <Grid
            container
            mr={{ sx: 0, md: 6 }}
            alignItems={"center"}
            justifyContent={"end"}
            spacing={2}
            flexGrow={{ xs: 1, md: 0 }}
            flexWrap={"nowrap"}
            p={0}
          >
            {/* <Grid item sx={{ display: { xs: "none", sm: "inline-flex" } }}>
              <Link
                href="https://ded.stxavierskop.edu.in/"
                target="_blank"
                sx={{
                  minWidth: "120px",
                  textWrap: "nowrap",
                  bgcolor: "secondary.light",
                  padding: 0,
                  px: 0.5,
                  py: 0.5,
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  ":hover": {
                    bgcolor: "#eed261",
                  },
                }}
                underline="hover"
              >D.Ed College</Link>
            </Grid> */}
            {/* <Grid item sx={{ display: { xs: "none", sm: "inline-flex" } }}>
              <Link
                href="https://sxs.akronsystems.com/HR/pHRAPPLICATIONFORM.aspx"
                target="_blank"
                sx={{
                  minWidth: "120px",
                  textWrap: "nowrap",
                  bgcolor: "secondary.light",
                  padding: 0,
                  px: 2,
                  py: 0.5,
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  ":hover": {
                    bgcolor: "#eed261",
                  },
                }}
                underline="hover"
              >HR APPLICATION FORM</Link>
            </Grid> */}
            {/* <Grid item sx={{ display: { xs: "none", sm: "inline-flex" } }}>
              <Link
                href="https://sxs.akronsystems.com/pXESTFESTFORM.aspx"
                target="_blank"
                sx={{
                  minWidth: "120px",
                  textWrap: "nowrap",
                  bgcolor: "secondary.light",
                  padding: 0,
                  px: 2,
                  py: 0.5,
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  ":hover": {
                    bgcolor: "#eed261",
                  },
                }}
                underline="hover"
              >ZEST FEST REGISTRATION FORM 2025</Link>
            </Grid> */}
            {/* <Grid item sx={{ display: { xs: "none", sm: "inline-flex" } }}>
              <Link
                href="https://sxs.akronsystems.com/pFootBallRegistrationForm.aspx#"
                target="_blank"
                sx={{
                  minWidth: "120px",
                  textWrap: "nowrap",
                  bgcolor: "secondary.light",
                  padding: 0,
                  px: 2,
                  py: 0.5,
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  ":hover": {
                    bgcolor: "#eed261",
                  },
                }}
                underline="hover"
              >Football Tournament Registration Form</Link>
            </Grid>  */}
            <Grid item>
              <Link
                // href="https://sxs.akronsystems.com/admission/pONLINEFEEPAYMENT.aspx"
                href="https://sxs.akronsystems.com/admission/pFEEPAYMENT.aspx"
                target="_blank"
                sx={{
                  textWrap: "nowrap",
                  bgcolor: "#eed261",
                  padding: 0,
                  px: 0.5,
                  fontWeight: "bold",
                  color: "primary.main",
                  py: 0.5,
                  mt: 0.2,
                  ":hover": {
                    bgcolor: "secondary.light", // theme.palette.primary.main
                    color: "primary.main",
                  },
                  minWidth: "120px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "2px",
                }}
                underline="hover"
              >
                Pay Fees
                <ArrowRightAltIcon />
              </Link>
            </Grid>
            <Grid item sx={{ display: { xs: "none", sm: "inline-flex" } }}>
              <Link
                href="https://sxs.akronsystems.com/pLogin.aspx"
                target="_blank"
                underline="hover"
                sx={{
                  minWidth: "120px",
                  textWrap: "nowrap",
                  bgcolor: "secondary.light",
                  padding: 0,
                  px: 0.5,
                  py: 0.5,
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  ":hover": {
                    bgcolor: "#eed261",
                  },
                }}
              >
                {/* public\assets\images\webdesk_logo.png */}
                <img
                  src={`${constant?.baseurl}assets/images/webdesk_logo.png`}
                  alt="Webdesk Logo"
                  height="15px"
                  loading="lazy"
                />
                Login
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Header;
